import _ from 'lodash';
import { coins} from '@/api/const';
import contractApi from '@/api/contract';

export default {
  state: {
    contracts: [],
    summary: {
      ..._.chain(coins).map(c => [c, { issuers: new Set(), durationIssuers: new Map(), contracts: [] }]).fromPairs().value()
    }
  },
  namespaced: true,
  getters: {
    getSummary(state, getters, rootState) {
      return coin => ({
        ...state.summary[coin],
        contracts: state.summary[coin].contracts.map(c => contractApi.cloudMining.getFullData(c, coin, rootState.blockchain))
      });
    },
    findContract(state, getters, rootState) {
      return coin => state.contracts.filter(v => v.payoffType.indexOf(coin) >= 0).map(v => contractApi.cloudMining.getFullData(v, coin, rootState.blockchain));
    },
    getContractById(state, getters, rootState) {
      return (id, coin) => {
        const p = state.contracts.find(v => v.id === id);
        return p && contractApi.cloudMining.getFullData(p, coin, rootState.blockchain);
      }
    }
  },
  mutations: {
    setData(state, payload) {
      state.contracts = payload;
      _.chain(payload)
        .flatMap(c => c.payoffType.map(coin => ({ ...c, coin })))
        .sortBy(['coin', 'durationAlias', 'contract_cost'])
        .sortedUniqBy(v => {
          state.summary[v.coin].issuers.add(v.issuer);

          const { durationIssuers } = state.summary[v.coin];
          if (durationIssuers.has(v.durationAlias)) {
            durationIssuers.get(v.durationAlias).add(v.issuer);
          } else {
            durationIssuers.set(v.durationAlias, new Set([v.issuer]));
          }

          return v.coin + v.durationAlias;
        })
        .groupBy('coin')
        .forEach((contracts, coin) => state.summary[coin].contracts = _.sortBy(contracts, 'duration'))
        .value();
    }
  },
  actions: {
    async load({ commit }) {
      commit('setData', await contractApi.cloudMining.list());
    }
  }
}